const referenceParameter = ({
  referenceParameterNumber,
  refParameterNumber,
  releaseNumber,
  release,
}) =>
  `/reference-parameters/${referenceParameterNumber || refParameterNumber}/${
    releaseNumber || release
  }`

const supportParameter = ({ supportParameterNumber }) =>
  `/support-parameters/${supportParameterNumber}`

export default {
  referenceParameter,
  supportParameter,
}
